module.exports = __webpack_public_path__ + "img/pic_12.7f31b657.jpg";